import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import { RadioGroup, Radio } from 'react-radio-group'

import './styles.css'

function DeliveryMethods({ methods = [], selected = '', chooseDeliveryMethod = () => {}, ...props }) {
  return (
    <div id="DeliveryMethods">
      <RadioGroup name="deliveryMethods" selectedValue={selected} className="radio-group">
        {methods && methods.map((method, index) => (
          <div
            className={classnames('method', { selected: method.code === selected })}
            key={method.code}
            onClick={() => chooseDeliveryMethod(method.code, method.cost)}
            role="button"
            tabIndex={0}
            onKeyUp={(e) => e.key === 'Enter' && chooseDeliveryMethod(method.code, method.cost)}
          >
            <label>
              <div className="radio-input">
                <Radio
                  value={method.code}
                  key={method.code}
                />
              </div>
              <div className="icon">
                <i className={`icon-truck-${3 - methods.length + index < 1 ? '0' : 3 - methods.length + index}`} />
              </div>
              <div className="description">
                <span>{method.name}</span>
                <span>{method.description}</span>
                {method.warning && <span className="warning">{method.warning}</span>}
              </div>
              <div className="cost">${parseFloat(Math.round(method.cost * 100) / 100).toFixed(2)}</div>
            </label>
          </div>
        ))}
      </RadioGroup>
    </div>
  )
}

export const deliveryMethodsPropTypes = {
  code: PropTypes.string.isRequired,
  cost: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  warning: PropTypes.string
}

DeliveryMethods.propTypes = {
  methods: PropTypes.arrayOf(PropTypes.shape(deliveryMethodsPropTypes)),
  selected: PropTypes.string,
  chooseDeliveryMethod: PropTypes.func
}

export default DeliveryMethods
